import React from "react";
import "./Loader.scss";
import _ from "lodash";

export const CssLoader = ({ className }) => (
  <div className={`lds-spinner ${className}`}>
    {_.range(12).map((i) => <div key={i}></div>)}
  </div>
);
